






































import Vue from "vue";
import coreApiClient from "@/services/apis/coreApiClient";
import userManager from "@/services/userManager";

export default Vue.extend({
  data() {
    return {
      self: this,
      item: null,
      currentTab: "",
      permitted: false,
      tabs: {
        accounts: {
          label: "Tài khoản ngân hàng",
          condition() {
            return userManager.checkRole(["kt"]);
          },
        },
      },
    };
  },
  async created() {
    this.item = await coreApiClient.call("paymentPartners", "findById", {
      id: this.$route.params.paymentPartnerId,
    });
  },
});
